module.exports = __webpack_public_path__ + "static/erin-be189099b24bbb14a19360b564ac9ecb.jpg";